import ContactComp from '../components/contactsComp';

const Contacts = () => {
    return <ContactComp />;
};

export default Contacts;
